import { VesselScenarioContainer } from '../../interfaces/VesselScenario';
import { largeRound } from '../common';

/**
 * Looks up the absolute bollard index from a scenario bollard using the pre-built lookup map.
 * Returns the index or -1 if not found.
 */
export const lookupBollardIndex = (
  scenarioBollards: VesselScenarioContainer['data']['port']['bollards'],
  relativeIndex: number,
  bollardMap: Map<string, number>,
): number => {
  if (relativeIndex > scenarioBollards.length - 1) return -1;

  const scenarioBollard = scenarioBollards[relativeIndex];
  if (!scenarioBollard) return -1;

  const key = `${largeRound(scenarioBollard.coordinates.x)},${largeRound(scenarioBollard.coordinates.y)}`;

  return bollardMap.get(key) ?? -1;
};
